<template>
<div style="height:100%; width:100%; position: relative;">
  <m-carecenter-edit-form :form="form" :carecenter="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-carecenter-edit-form>
  <div class="poi-search">
    <v-toolbar
    class="toolbar elevation-0"
      dense
      height="36px" icon-h-logo-hart-black
      style="overflow: hidden;"
    >
        <div class="toggle-poi elevation-0" >
          <v-btn icon color="grey" @click="refresh">
            <v-icon color="grey">refresh</v-icon>
          </v-btn>
        </div>
    <span style="margin: 0; ">
      <v-btn-toggle v-if="showPoi" v-model="poi" class="toggle-poi elevation-0" multiple>
        <v-btn icon color="grey" value="driver">
          <v-icon color="grey">directions_car</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle class="toggle-poi elevation-0">
        <v-btn icon color="grey" value="true" @click="toggleTraffic">
          <v-icon color="grey">traffic</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle v-if="showPoi" v-model="poi" class="toggle-poi elevation-0" multiple>
        <v-btn icon color="grey" value="client">
          <v-icon color="grey">person_pin</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle  v-if="showPoi" v-model="poi" class="toggle-poi elevation-0" multiple>
        <v-btn icon color="grey" value="destination">
        <v-icon color="grey">local_hospital</v-icon>
        </v-btn>
      </v-btn-toggle>
    </span>
    <span class="ml-3" v-show="filteredPoi.length > 0">
      <v-btn-toggle text v-model="routeTool" class="toggle-poi elevation-0">
        <v-btn icon color="grey" text :value="true">
          <v-icon color="grey">directions</v-icon>
        </v-btn>
      </v-btn-toggle>

    </span>
    <span style="margin: 0; ">

    </span>
    <span style="margin: 0; " v-if="filteredPoi.length > 0 && routeTool">
        <v-autocomplete
          flat
          v-bind:items="driversList"
          v-model="selectedDriver"
          label="Driver"
          item-value="data"
          single-line
          :menu-props="{
            bottom: ''
          }"
          return-object
          autocomplete
          solo
          dense
          hide-details
          @change="showDirection"
      ></v-autocomplete>
    </span>

    <span style="margin: 0; " v-show="filteredPoi.length > 0 && routeTool">
        <v-autocomplete
        ref="selectPoi"
        flat
        v-bind:items="filteredPoi"
        v-model="selectedPoi"
        :search-input.sync="searchIn"
        label="Destination"
        single-line
        :menu-props="{
          bottom: ''
        }"
        return-object
        autocomplete
        solo
        dense
        hide-details
        @change="showDirection"
      ></v-autocomplete>
    </span>
 <span style="margin: 0; " v-show="filteredPoi.length > 0 && routeTool">
   <div class="px-3" v-if="driverRoute">{{ driverRoute.duration }} - {{ driverRoute.distance }}</div>
   </span>
    </v-toolbar>


  </div>

    <div style="position: relative; height: 100%; background: rgba(255,255, 255, 0.6);">

      <div v-if="driversCoord.length > 0" class="drivers-overlay">
        <div class="drivers-item" v-for="(item, i) in driversList" :key="i" @click.stop="showDriver(item)">
          <v-icon>drive_eta</v-icon> {{ item.driver | cleanName }}
        </div>
      </div>

      <div v-if="(socketUsers.length  > 0) && showSockets" class="drivers-overlay socket-drivers">
        <div>
          <div class="drivers-item" v-for="(item, i) in socketUsers" :key="i" @click.stop="getInfo(item)">
            <v-icon color="primary">smartphone</v-icon> {{ item.id}}.{{item.lastname}}
          </div>
          <v-btn text color="primary" x-small block class="mt-3" @click="showSockets=false">
            fermer
          </v-btn>
        </div>
      </div>
      <div v-if="(socketUsers.length  > 0) && !showSockets" class="btn-socket-drivers">
        <v-btn icon outlined color="grey" @click="showSockets=true">
          <v-icon color="primary">smartphone</v-icon>
        </v-btn>
      </div>

      <div class="google-map" :class="{'hide-marker': hideLabels}" :id="mapName"></div>
    </div>

  </div>
</template>
<script>
import moment from 'moment';
import styles from '@/components/googlemaps/styles';
// import DMarker from '@/components/googlemaps/DMarker';
import MarkerWithLabel from './markerWithLabel';
//import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
// import Autocomplete from '@/components/common/autocomplete';
import CareCenterMixin from '@/mixins/carecenter';
import geojsonData from './brussels.json';
export default {
  name: 'google-map',
  mixins: [CareCenterMixin],
  props: ['name', 'driversCoord'],
  data: function () {
    return {
      mapName: this.name + '-map',
      icon_client: {
        path: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z',
        fillColor: '#E5332A',
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        anchor: new google.maps.Point(12, 18)
      },
      icon_destination: {
        path: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z',
        fillColor: 'white',
        fillOpacity: 1,
        scale: 1,
        strokeColor: '#E5332A',
        strokeWeight: 1,
        anchor: new google.maps.Point(12, 12)
      },
      icon_carecenter: {
        path: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z',
        fillColor: '#CCCCCC',
        fillOpacity: 1,
        scale: 1,
        strokeColor: '#E5332A',
        strokeWeight: 1,
        anchor: new google.maps.Point(12, 12)
      },
      icon_driver: {
        path: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z',
        fillColor: '#CCCCCC',
        fillOpacity: 1,
        scale: 1.2,
        strokeColor: '#E5332A',
        strokeWeight: 1,
        anchor: new google.maps.Point(12, 12)
      },
      map: null,
      MarkerLabel: null,
      bounds: null,
      showSockets: false,
      drivers: [],
      HQloc: [[50.8554, 4.40647],[50.864922, 4.333736]],
      markers: {
        driver: [],
        client: [],
        destination: [],
        carecenter: []
      },
      search: [],
      poi: [],
      showPoi: false,
      hideLabels: true,
      selectedPoi: null,
      selectedDest: null,
      selectedDriver: null,
      searchIn: null,
      directionsService: null,
      directionsDisplay: null,
      trafficLayer: null,
      traffic: false,
      routeTool: false,
      driverRoute: null,
      routeInfoWindow : []
    };
  },
  methods: {
    iconColor (icon, fillColor) {
      icon.fillColor = fillColor;
    },
    refresh () {
      this.$emit('refresh');
    },
    update () {
       // var markers = this.markers.driver;
       var app = this;
      for (var i = 0; i < this.drivers.length; i++) {
        google.maps.event.clearInstanceListeners(this.drivers[i]);
        this.drivers[i].setMap(null);
      }
      this.drivers = [];
      this.markers.driver = [];

      // this.cleanMarkers(this.drivers);
      this.driversCoord.forEach(coord => {
        var battery = null;
        var markerContent = ''
        var markerLabel = ''
        var marker = coord.setMarker();
        coord.checkGeofences(this.markers);
        var infoWindow = new google.maps.InfoWindow({
          disableAutoPan: true
        });
        var labelWindow = new google.maps.InfoWindow({
          disableAutoPan: true
        });

        google.maps.event.addListener(marker, 'click', function () {
          // infoWindow.open(this.map, marker);
          // labelWindow.close(this.map, marker);
          console.log('marker clicked');
          coord.getBookings().then((result) => {
            app.openTrips(result);
            /*
            if (result.length) {
              app.openTrips(result);
            } else {
              var data = '<span style="color: #E5332A"><strong>Pas de transports</span>';
                labelWindow.close(this.map, marker);
                infoWindow.setContent(data);
                infoWindow.open(this.map, marker);
            }
            */

          });

        });

        if (coord.data && coord.data.position) {

          var speed = coord.data.position.coords.speed;
          speed = (speed && speed > 1) ? Math.floor(speed * 3.6) : 0;

          markerContent = '<span style="color: #E5332A"><strong>' + coord.driver + '</span>';
          if (speed > 0) {
            markerContent += '<br> <strong>Speed: </strong> ' + speed + ' km/h';
          }
         markerLabel = markerContent;
          if (coord.data.position.activity) {
            markerContent += '<br> <strong>Activity: </strong> ' + coord.data.position.activity.type;
          }
          if (coord.data.time) {
            markerContent += '<br> <strong>Time: </strong> ' + moment(coord.data.time).format('DD-MM-YY HH:mm');
          }
          if (coord.data.position.battery || coord.battery) {
            battery = coord.battery || coord.data.position.battery;
            markerContent += '<br> <strong>Battery: </strong> ' + parseInt(battery.level * 100) + '%';
            markerContent += '<br> <strong>isCharging: </strong> ' + battery.is_charging;
          }
          // infoWindow.open(this.map, marker);
          infoWindow.setContent(markerContent);
        } else {
          markerContent = '<span style="color: #E5332A"><strong>' + coord.driver + '</span>';
          markerLabel = markerContent;
        }


        labelWindow.setContent(markerLabel);
        labelWindow.open(this.map, marker);

        marker.setMap(this.map);
        this.drivers.push(marker);
        this.markers.driver.push(marker);

        // this.map.fitBounds(this.bounds.extend(position));
        // this.map.setZoom(16);
      });
    },
    openTrips (list) {
      // console.log('open trips');
      this.$bus.$emit('driverTrips', list);
    },
    toggleMarker (item) {
      var selectedItem = this.poi.find(i => i === item);
      var markers = this.markers[item];
      var show = false;
      if (selectedItem) {
        show = true;
      }
      for (var i = 0; i < markers.length; i++) {
        // markers[i].setMap(show);
        markers[i].setVisible(show);
      }
    },
    cleanMarkers (markers) {
      var m = markers;
      for (var i = 0; i < m.length; i++) {
        m[i].setMap(null);
      }
      m = [];
    },
    getToday () {
      var startDate = moment().format('YYYY-MM-DD');

      return new Promise((resolve) => {
        this.$http
        .post('service/booking/byDate', {startDate})
        .then(response => {

          // var result = response.data

          const clients = [];
          const destinations = [];
          const drivers = [];
          let map = new Map();
          for (const item of response.data) {
            if(!map.has(item.destination_id)){
              map.set(item.destination_id, true);    // set any value to Map
              destinations.push({
                data: {
                  fullAddress: item.destination_address,
                },
                label: item.destination_name || null,
                text: item.destination_name || null,
                value: item.destination_id,
                pos: { latitude: item.destination_lat, longitude: item.destination_long}
              });
            }
          }
          map = new Map();
          for (const item of response.data) {
            if(!map.has(item.client_id)){
              map.set(item.client_id, true);    // set any value to Map
              clients.push({
                  data: {
                    pick_time: item.pick_time,
                    fullAddress: item.pick_address,
                    destination: item.destination_name || null,
                    driver: item.driver_lastname || null
                  },
                  label: item.name || (item.client_lastname + ' ' + item.client_firstname),
                  text: item.name || (item.client_lastname + ' ' + item.client_firstname),
                  value: item.client_id,
                  booking_id: item.id,
                  client_id: item.client_id,
                  destination_id: item.destination_id,
                  driver_id: item.driver_id,
                  pos: { latitude: item.client_lat, longitude: item.client_long}
              });
            }
          }

          this.setMarkers(clients, 'client');
          this.setMarkers(destinations, 'destination');

          resolve({clients, destinations, drivers});
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      });
    },
    getMarkerData (type) {
      return new Promise((resolve) => {
        this.$http
        .get('api/' + type)
        .then(response => {
          var result = response.data.filter(function (d) {
            return d.latitude && d.longitude;
          }).map(data => {
            return {
              data: data,
              label: data.lastname || data.name,
              text: data.name || (data.lastname + ' ' + data.firstname),
              value: data.id,
              pos: {
                latitude: data.latitude,
                longitude: data.longitude
              }
            }
          })
          // console.log('result ---', result);
          resolve(result);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      });
    },
    getDrivers () {
      var startDate = moment().format('YYYY-MM-DD');

      return new Promise((resolve) => {
        this.$http
        .get('service/driver/active')
        .then(response => {

          const drivers = [];
          let map = new Map();
          console.log('drivers', response.data)
          for (const item of response.data) {
            if(!map.has(item.id)){
              // map.set(item.destination_id, true);
              // set any value to Map
              drivers.push({
                data: {
                  fullAddress: item.fullAddress,
                },
                label: item.lastname + ' ' + item.firstname || null,
                text: item.lastname + ' ' + item.firstname || null,
                value: item.id,
                pos: { latitude: item.latitude, longitude: item.longitude}
              });
            }
          }
          this.setMarkers(drivers, 'driver');

          console.log(drivers)
          resolve({drivers});
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      });
    },
    getData () {
    },
    posRandom (pos) {
      var newPos = Number(pos) + (Math.random() / 8000);
      return newPos
    },
    setMarkers (data, type, noAnim) {
      return new Promise((resolve) => {
        var app = this;
        // console.log('setDestinations', data);
        var markers = app.markers[type];
        var search = app.search;
        data.forEach(coord => {
          // const position = new google.maps.LatLng(this.posRandom(coord.pos.latitude), this.posRandom(coord.pos.longitude));
          const position = new google.maps.LatLng(coord.pos.latitude, coord.pos.longitude);
          const markerOpt = {
            title: coord.label,
            icon: this['icon_' + type],
            map: this.map,
            draggable: true,
            animation: (noAnim) ? null : google.maps.Animation.DROP,
            labelContent: '<div class="label-marker">' + coord.label + '</div>',
            labelAnchor: new google.maps.Point(-10, 20),
            labelClass: 'mylabelMarker', // the CSS class for the label
            labelInBackground: true,
            position,
            data: coord.data
          };

          if (type === 'carecenter' && coord.data.visited) {
            markerOpt.icon = Object.assign({}, markerOpt.icon);
            markerOpt.icon.fillColor = '#0dba47';
          }
          if (type === 'carecenter' && coord.data.marked) {
            markerOpt.icon = Object.assign({}, markerOpt.icon);
            markerOpt.icon.fillColor = '#000000';
          }
          if (type === 'carecenter' && coord.data.subscribed_id) {
            markerOpt.icon = Object.assign({}, markerOpt.icon);
            markerOpt.icon.fillColor = '#E5332A';
          }

          const marker = new this.MarkerLabel(markerOpt);
          // var fence = new google.maps.Circle({radius: 60, center: position});
          var fence = new google.maps.Circle({
            map: this.map,
            radius: 25,
            center: position,
            fillColor: '#fff',
            fillOpacity: 0.6,
            strokeColor: '#313131',
            strokeOpacity: 0.4,
            strokeWeight: 0.8
          })
          marker.fence = fence;
          marker.fence.bindTo('center', marker, 'position');

          var infoWindow = new google.maps.InfoWindow();

          google.maps.event.addListener(marker, 'click', function () {
            var markerContent = '<span style="color: #E5332A"><strong>' + coord.label + '</strong></span><br>' + coord.data.fullAddress+ '<br>';
            if (coord.data.pick_time) {
              markerContent += '<br> <strong>Pickup time: </strong>' + coord.data.pick_time;
            }
            if (coord.data.destination) {
              markerContent += '<br> <strong>Destination: </strong> ' + coord.data.destination;
            }
            if (coord.data.driver) {
              markerContent += '<br> <strong>Driver: </strong> ' + coord.data.driver;
            }
            if (coord.data.email && coord.data.email.indexOf('no-email.be') === -1) {
              markerContent += '<br> <strong>email:</strong> ' + coord.data.email;
            }
            if (coord.data.tel || coord.data.mobile) {
              markerContent += '<br> <strong>tel:</strong> ' + (coord.data.tel || coord.data.mobile);
            }
            // markerContent += '<div @click="hello()">click</div>';

            infoWindow.setContent(markerContent);
            infoWindow.open(this.map, marker);
          });

          google.maps.event.addListener(marker, 'dblclick', function () {
            // console.log('dubble clicked', coord.data)
            app.editItem(coord.data);
          })

          marker.setVisible(false);
          // marker.setMap(app.map);
          markers.push(marker);
          coord.marker = marker;
          coord.fence = marker.fence;
          coord.type = type;
          search.push(coord);
          // this.map.fitBounds(this.bounds.extend(position));
          // this.map.setZoom(16);
        });
        resolve(markers);
        // console.log('setMarkers', markers);
      });
    },
    goto (obj) {
      var app = this;
      app.map.setZoom(12);
      window.setTimeout(() => {
        app.panPoi(obj);
      }, 1000);
    },
    panPoi (obj) {
      if (obj.pos && obj.pos.latitude) {
        // event.stopPropagation();
        this.map.setZoom(13);
        var latLng = new google.maps.LatLng(obj.pos.latitude, obj.pos.longitude);
        this.map.panTo(latLng);
        this.map.setZoom(15);
        obj.marker.setAnimation(4);
      }
      // console.log('selected:', this.selectedPoi);
      // console.log('selectPoi:', this.$refs.selectPoi);

      this.$nextTick(this.resetPoi);
      // this.$refs.selectPoi.inputValue = null;
    },
    afterselection (item) {
      var app = this;
      // console.log('afterselection', item);
      this.panPoi(item);
      this.$nextTick(() => {
        app.resetPoi();
      })
    },
    editItem (item) {
      this.reset();
      this.selectedItem = item;
      this.dialog_edit = true;
      // console.log('edit', this.selectedItem.id);
    },
    updateForm (data) {
      var app = this;
      var type = 'carecenter';
      this.updateCarecenter(data, function () {
        // console.log('updateCarecenter done');
        app.cleanMarkers(app.markers[type]);
        app.getMarkerData(type).then((result) => {
          app.setMarkers(result, type, true).then(() => {
            app.toggleMarker(type);
          })
        });
      });
    },
    resetPoi () {
      var app = this;
      this.selectedPoi = null;
      this.selectedDriver = null;
      this.driverRoute = null;
      window.setTimeout(function () {
        this.searchIn = null;
        // app.$refs.selectPoi.hideMenu();
      }, 100);
      // console.log('reset selected:', this.$el);
    },
    panMe (latitude, longitude) {
      var latLng = new google.maps.LatLng(latitude, longitude);
      this.map.panTo(latLng);
    },
    addHQ () {
      var markers = [];
      this.HQloc.forEach((loc)=> {
        var marker = this.addMarker (loc[0], loc[1], 'logo-hq.png');
        markers.push(marker);
      })
      return markers;
    },
    addMarker (lat, lon, img) {
      var position = new google.maps.LatLng(lat, lon);
      var icon = {
        url: 'img/' + img,
        anchor: new google.maps.Point(0, 0),
        scaledSize: new google.maps.Size(23, 20)
      }

        var marker = new google.maps.Marker({
        //var marker = new google.maps.marker.AdvancedMarkerElement({
        position,
        map: this.map,
        draggable: true,
        icon: icon
      });

      return marker;
    },
    showRoute (data) {
      // console.log('showRoute', data)
      var app = this;
      data.travelMode = 'DRIVING';
      // data.optimizeWaypoints= true;
      app.directionsDisplay.setDirections({routes: []});
      app.directionsService.route(data, function (response, status) {
        if (status === 'OK') {
          // console.log(response.routes)
          app.computeTotalDistance(response)
          app.directionsDisplay.setDirections(response);

          app.cleanInfoWindows();
          response.routes[0].legs.forEach((leg, i) => {

            var routeInfo = '<span class="routeInfo">' + leg.duration.text + ' - ' + leg.distance.text + '</span>';
            var loc = i > 0 ? leg.end_location : leg.start_location;
            if (!app.routeInfoWindow[i]) {
              app.routeInfoWindow[i] = new google.maps.InfoWindow();
            }
            app.routeInfoWindow[i].setContent(routeInfo);
            app.routeInfoWindow[i].setPosition(loc);
            app.routeInfoWindow[i].open(app.map);
          })

        } else {
          // console.log('Directions request failed due to ' + status);
        }
      });
    },
    showDriver (loc) {
      // console.log('showDriver:', loc.pos);
      this.panMe(loc.pos.latitude, loc.pos.longitude);
    },
    getInfo (user) {
      this.$socket.client.emit('action', {
        to: user.id,
        from: this.user.id,
        action: 'getInfo'
      });
    },
    toggleDirection (item) {
      if (this.selectedDriver === item) {
        this.selectedDriver = null;
      } else {
        this.selectedDriver = item;
      }
    },
    showDirection () {
      this.$nextTick(() => {
        // console.log('selectedDriver', this.selectedDriver)
        // console.log('selectedPoi:', this.selectedPoi);

        if (this.selectedDriver && this.selectedPoi) {
          this.showRoute({
            origin: this.selectedDriver.pos.latitude + ',' + this.selectedDriver.pos.longitude,
            destination: this.selectedPoi.pos.latitude + ',' + this.selectedPoi.pos.longitude
          });
        } else {
          if (this.selectedPoi) {
            this.panPoi(this.selectedPoi);
          }
        }
      })
    },
    computeTotalDistance (result) {
      // console.log('computeTotalDistance:', result);
      var myroute = result.routes[0];
      this.driverRoute = {
        distance: myroute.legs[0].distance.text,
        duration: myroute.legs[0].duration.text
      }
    },
    loadGeoJsonString(geoString) {
      console.log(geoString)
      var geojson = geoString // JSON.parse(geoString);
      this.map.data.addGeoJson(geojson);
    },
    toggleTraffic () {
      if(this.trafficLayer.getMap() == null){
          //traffic layer is disabled.. enable it
          this.trafficLayer.setMap(this.map);
      } else {
          //traffic layer is enabled.. disable it
          this.trafficLayer.setMap(null);
      }
    },
    initMap () {
      var app = this;
      this.bounds = new google.maps.LatLngBounds();
      const element = document.getElementById(this.mapName);
      const options = {
        mapTypeControl: false,
        center: { lat: 50.86, lng: 4.39 },
        disableDefaultUI: false,
        zoom: 12,
        styles: (styles && styles.simple) || null
      };
      this.map = new google.maps.Map(element, options);
      this.MarkerLabel = MarkerWithLabel(google.maps);
      google.maps.event.addListener(this.map, 'zoom_changed', function () {
        // console.log('zoom_changed', app.map.getZoom());
        app.hideLabels = (app.map.getZoom() < 15);
      });
      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer({
        suppressMarkers: true
      });
      this.trafficLayer = new google.maps.TrafficLayer();
      this.directionsDisplay.setMap(this.map);

      this.addHQ();
      // this.loadGeoJsonString(geojsonData);
      // this.showTrafic();
      // this.update();
    },
    cleanInfoWindows () {
      this.routeInfoWindow.forEach((w) => {
        if (w !== null) {
            google.maps.event.clearInstanceListeners(w);  // just in case handlers continue to stick around
            w.close();
            w = null;
        }
        this.routeInfoWindow = [];
      })
    },
    cleanAll() {
      this.drivers.forEach((marker) => {
        console.log('clean', marker)
        google.maps.event.clearInstanceListeners(marker);
      })
    },
    test (data) {
      console.log('test', data);
    }
  },
  watch: {
    routeTool (value) {
      if (!value) {
        this.resetPoi()
      }
      // this.setDestinations();
    },
    poi () {
      var app = this;
      ['client', 'driver', 'destination', 'carecenter'].forEach((i) => {
        if (this.markers[i].length) {
          this.toggleMarker(i);
        }
      })
    }
  },
  computed: {
    driversList: {
      cache: false,
      get () {
        return Object.values(this.driversCoord);
      }
    },
    dynComponent () {
      const template = this.content ? this.content : '<div>nothing here yet</div>'
      return {
        template, // use content as template for this component
        props: this.$options.props // re-use current props definitions
      }
    },
    filteredPoi () {
      return this.search.filter((item) => {
        return this.poi.find(i => i === item.type);
      })
    },
    user: {
      cache: false,
      get () {
        return this.$store.getters.user;
      }
    },
    socketUsers: {
      cache: false,
      get () {
        return this.$store.getters.socket_users.filter((user) => user.role === 'driver' && user.active);
      }
    }
  },
  mounted: function () {
    var app = this;
    this.initMap();

    this.getToday().then((result) => {
      app.showPoi = true;
      this.getDrivers();
      //
    })
  },
  beforeDestroy () {
    this.cleanAll();
  },
  filters: {
    cleanName (v) {
      return v.replace('_', '. ');
    }
  }
};
</script>
<style lang="scss">
.theme--light {
  .poi-search {
    position: absolute;
    z-index:2;

    .v-toolbar {
      border: solid 1px grey;
      background: rgba(255,255, 255, 0.9);
      .v-toolbar--floating {
        margin: 0px;
      }
    }

    .v-input-group--select.v-input-group--focused.v-input-group--open .v-input-group__append-icon:not(.v-input-group__icon-clearable) {
      transform: rotate(0deg);
    }

    .v-input-group {
      padding: 0;
      &.v-input-group--solo{
        background: transparent;
      }
    }
    .v-text-field--solo>.v-input__control>.v-input__slot {
      background: transparent;
    }
    .toggle-poi {
      background: transparent;
      .btn-toggle {
        background: transparent;
      }
      .v-btn {
        border: none;
      }
    }
    .theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
        background: transparent;
    }
  }
}
.label-marker{
  padding: 2px 5px;
  border: solid 1px #E5332A;
  color: #3b3b3b;
  background: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}
.hide-marker {
  .label-marker {
    display: none;
  }
}

.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: gray;
  z-index: 0;
  .routeInfo {
    color: rgb(56, 125, 228);
    font-weight: bold;
  }
  .gm-style-iw {
    max-width: 250px !important;
    & + div {
      display: block;
    }
    #iw-container  .iw-title {
      font-size: 10px;
      padding: 0;
      background-color: #48b5e9;
    }
  }

}
</style>
